import {useForm} from "@mantine/form";
import {useTranslation} from "react-i18next";
import {Button, Modal, ModalProps, TextInput} from "@mantine/core";
import {useCallback} from "react";
import {DateInput} from "../../date/DateInput/DateInput";

interface PipelineGraphFormProps {
  options?: PipelineGraphFormOptions;
  defaultValues?: Partial<PipelineGraphFormValues>;
  onSubmit?: (values: PipelineGraphFormValues) => void;
  submitting?: boolean;
}

export interface PipelineGraphFormOptions {
  // props here
}

export interface PipelineGraphFormValues {
  displayName: string
  effectiveDate: Date
}

const getDefaultValues = (defaultValues: Partial<PipelineGraphFormValues> | undefined) => {
  return {
    displayName: defaultValues?.displayName,
    effectiveDate: defaultValues?.effectiveDate,
  }
}

export const PipelineGraphForm = (props: PipelineGraphFormProps) => {
  const {
    options,
    defaultValues,
    onSubmit,
    submitting = false
  } = props;

  const {t} = useTranslation(["common"]);

  const form = useForm({
    initialValues: getDefaultValues(defaultValues),
    validate: {}
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {
    if (onSubmit) {
      onSubmit({
        displayName: values.displayName!,
        effectiveDate: values.effectiveDate!,
      });
    }
  }, [form, onSubmit]);

  return (
    <form onSubmit={form.onSubmit(onFormSubmit)}>
      <TextInput
        label={t("common.entity.pipelinegraph.form.field.name", "Name")}
        placeholder={t<string>("common.entity.pipelinegraph.form.field.name.placeholder", "Name")}
        styles={{wrapper: {width: "100%"}}}
        withAsterisk={true}
        required={true}
        {...form.getInputProps("displayName")} />
      <DateInput
        label={t("common.entity.pipelinegraph.form.field.effectivedttm", "Effective")}
        placeholder={t<string>("common.entity.pipelinegraph.form.field.type.effectivedttm", "Effective")}
        valueFormat="MM/DD/YYYY HH:mm"
        styles={{wrapper: {width: "100%"}}}
        popoverProps={{
          withinPortal: true
        }}
        withAsterisk={true}
        required={true}
        {...form.getInputProps("effectiveDate")} />
      <Button type="submit" loading={submitting} fullWidth mt="xl">
        {t("common.action.submit", {ns: "common"})}
      </Button>
    </form>
  );
};

interface PipelineGraphFormModalProps extends PipelineGraphFormProps, Omit<ModalProps, 'onSubmit'> {

}

export const PipelineGraphFormModal = (props: PipelineGraphFormModalProps) => {
  const {
    defaultValues,
    onSubmit,
    submitting,
    ...rest
  } = props;

  return (
    <Modal {...rest}>
      <PipelineGraphForm defaultValues={defaultValues} onSubmit={onSubmit} submitting={submitting}/>
    </Modal>
  );
};
